import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMessage.scss';

// 1. Destructure and set defaults in the signature for cleaner logic
const ErrorMessage = ({
  heading = 'Sorry, something went wrong on our end',
  body = "We're working to fix the issue. If refreshing the page doesn't help, please try again later."
}) => {
  return (
    <div className="error-message__container">
      <h2 className="error-message__heading">{heading}</h2>
      <p>{body}</p>
    </div>
  );
};

ErrorMessage.propTypes = {
  heading: PropTypes.string,
  body: PropTypes.string
};

export default ErrorMessage;
